import { action } from 'typesafe-actions';
import * as types from './navigation.actionTypes'

export const setShowSidebar = (value: boolean) => action(types.SET_SHOW_SIDEBAR, { value })